import { constants } from '../constants';

interface IBreadcrumbsData {
  link: string;
  text: string;
}

export const BreadcrumbsSchema = (breadcrumbData: IBreadcrumbsData[]) => {
  breadcrumbData = Object.values(breadcrumbData);
  return (
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': breadcrumbData.map((data: IBreadcrumbsData, index: number) => ({
          '@type': 'ListItem',
          'position': index + 1,
          'name': data.text,
          'item': `${constants.url}${data.link}`,
        })),
      })}
    </script>
  );
};

